import React from "react";
import Zip from "../../assets/Celo Rake game.zip";
import Backimg from "../../assets/ceelorake.jpeg";
import WhyChooseUsCeelorake from "../../Component/WhyChooseUsCeelorake";
const Ceelorake = () => {
  const handleDownload = () => {
    // Replace 'your-zip-file.zip' with the actual path to your zip file
    const zipFileURL = Zip;

    // Create a link element
    const link = document.createElement("a");

    // Set the href attribute to the zip file URL
    link.href = zipFileURL;

    // Set the download attribute with the desired file name
    link.download = "Celo Rake game.zip";

    // Append the link to the document
    document.body.appendChild(link);

    // Trigger a click event on the link to start the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  };

  return (
    <>
      <WhyChooseUsCeelorake />
      <div
        style={{
          height: "100vh",
          width: "100%",
          marginTop: "30px",
          marginBottom: "30px",
          background: `url('${Backimg}') center`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1 className="text-center">How To Play</h1>
          </div>
          <div className="col-md-4">
            <iframe
              width="95%"
              height="300px"
              src="https://www.youtube.com/embed/jCDmr-cHNVs?si=oMGEOeCIDQvSTSOZ"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <div className="col-md-4">
            <iframe width="95%" height="300px" src="https://www.youtube.com/embed/1f86Kt5Yy74?si=gr3bt585GmAn_BQ1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
          <div className="col-md-4">

            <iframe width="95%" height="300px" src="https://www.youtube.com/embed/boNs0F3MgvY?si=VxWaL74rVrNyC-Ax" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
        </div>
      </div>
      <div className="button-wrapper d-flex justify-content-center mt-5">
        <button className="cmn--btn active btn--lg" onClick={handleDownload}>
          <i className="las la-download"></i> Download
        </button>
      </div>
      <p className="text-center my-4"><small className="text-warning">math report and additional rules and regulations</small></p>
    </>
  );
};

export default Ceelorake;
